import { useQuery } from '@tanstack/react-query';
import { StockLevel } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const STOCK_LEVELS_QUERY_KEY = ['stockLevels'];

export const useStockLevels = (warehouseId?: string) => {
  return useQuery<StockLevel[], Error>({
    queryKey: [...STOCK_LEVELS_QUERY_KEY, warehouseId],
    queryFn: async () => {
      const stockLevels = await warehouseService.getStockLevels(warehouseId);
      return stockLevels || [];
    },
    staleTime: 2 * 60 * 1000, // 2 minutes - stock levels change more frequently
  });
};

export default useStockLevels;
